import React from "react";

import { SignIn } from "../../../modules/signIn/SignIn";

export function SignInPage() {
  return <SignIn />;
}
